import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApplicationService } from 'src/app/services/application/application.service';
import { Application } from 'src/app/model/Application';
import { TableComponent } from 'src/app/components/table/table.component';
import { ColumnDefinition, ServiceInterface, TableConstruct } from 'src/app/model/Table';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/constants/app-constants';

/** Column definitions for the table */
const columnDefinitions: ColumnDefinition<Application>[] = [
  { header: "Sent By", field: "sentBy" },
  { header: "Business Legal Name", field: "businessName" },
  { header: "Business DBA", field: "businessDBA" },
  { header: "Applied On", field: "appliedOn", format: "date", toStringTransform: (x) => new Date(x).toDateString() },
  { header: "Status", field: "status", format: "status" },
];

/**
 * ApplicationsPage represenents the 'applications' menu
 */
@Component({
    selector: 'app-applications',
    templateUrl: './applications-page.component.html',
    styleUrl: './applications-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationsPageComponent {
  /** Columns to display in the table */
  // NOTE: this can be changed dynamically later
  public displayedColumns: string[] = columnDefinitions.map(x => x.field);

  /** Reference to the application table element */
  @ViewChild("applicationTable") table!: TableComponent<Application>;

  /** Construct table reference */
  public construct: TableConstruct<Application>;

  /**
   * Constructor for the application page to initialize services and set a base snapshot
   *
   * @param _applicationService
   */
  constructor(
    private readonly _applicationService: ApplicationService,
    private readonly _router: Router,
  ) {
    // Create a mock application service to provide to the table
    const mockService: ServiceInterface = {
      timeSinceLastRefresh$: this._applicationService.timeSinceLastRefresh$,
      changes$: this._applicationService.applications$,
      getEntities: () => this._applicationService.getApplications(),
    }

    // Create the table component
    this.construct = {
      source: new MatTableDataSource<Application>(),
      columns: columnDefinitions,
      displayedColumns: this.displayedColumns,
      service: mockService,
      paginationRange: [5, 10, 25, 100],
      fetchConstraints: this._createFetchConstraints(),
      settings: {sort: {enabled: true}},
    };
  }

  /**
   * Constraints on when to fetch customer data. A return of true
   * blocks the source update
   */
  private _createFetchConstraints(): () => boolean {
    const self = this;

    return (): boolean => {
      return !self._router.url.endsWith(AppConstants.MENU_APPLICATIONS_INVITES);
    }
  }

  /**
   * Apply a filter to the table
   */
  public applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.table.construct.source.filter = filterValue.trim().toLowerCase();
  }

  /**
   * Export the table data to Excel
   */
  public exportApplicationsToExcel(): void {
    this.table.exportApplicationsToXlsx();
  }
}
